import {BaseService} from "@/core/services/BaseService";

class PolicySearchService extends BaseService<any> {
  endpoint = "/policy/search"
}

export default new PolicySearchService();